export const reports = {
    route: 'Berichte',
    overAll: 'Gesamt',
    byDevice: 'Nach Gerät',
    reportTitle: 'Dieser Bericht basiert auf den Messdaten deines Watt Meter vom Monat',
    compare: 'Dein monatlicher Verbrauch im Vergleich zum Vormonat:',
    kwhMissing: 'Bitte gib den Preis pro kWH in den Einstellungen zum Watt Meter ein',
    monthlyConsumption: 'Dein monatlicher Verbrauch (KWh):',
    mostRelevant: 'Die wichtigsten Verbraucher:',
    alwaysOn: 'Always ON Geräte',
    graphTips: 'Auf diesem Graphen zeigen dir die orangen Linien zu welcher Tageszeit (X-Achse) und an welchem Tag des Monats (Y-Achse) du das Gerät verwendet hast.',
    deviceReport: 'Stromverbrauch deines Gerätes:',
    savingPotentials: 'Einsparungspotentiale',
    myAvgKwh: 'Verbrauch meiner Geräte in den letzten 30 Tagen',
    avgKwh: 'Verbrauch der Geräte des gleichen Typs',
    myAvgW: 'Verbrauch meins Geräts in Watt',
    avgW: 'Verbrauch der Geräte des gleichen Typs in Watt',
    kwhCost: 'Kosten pro Kilowatt',
    wattUnit: 'watt',
    kwUnit: 'Kilowatt',
    mwUnit: 'Megawatt',
    kwhUnit: 'KWh',
    kgUnit: 'Kilogramm',
    costUnit: '€'
};
